var constants = require('../constants');
var api = require('../../../utils/api');
var passwordUtils = require('../passwordUtils');
var commonActions = require('../../common/actions/common');

var ResetPassword = (function() {

    var _requestReset = function() {
        return {
            type: constants.CREATE_RESET_REQUEST
        };
    }

    var _createResetSuccess = function(data) {
        return {
            type: constants.CREATE_RESET_SUCCESS,
            data: data.response,
            meta: {
                analytics: {
                    eventType: constants.CREATE_RESET_SUCCESS,
                    actionValue: 'response',
                    labelValue: 'success'
                }
            }
        };
    }

    var _createResetError = function(error) {
        return {
            type: constants.CREATE_RESET_ERROR,
            errors: error.data,
            meta: {
                analytics: {
                    eventType: constants.CREATE_RESET_ERROR,
                    actionValue: 'response',
                    labelValue: 'failure'
                }
            }
        };
    }

    var _validationError = function(error){
        return {
            type: constants.CREATE_RESET_ERROR,
            errors: error
        };
    }

    var _clearError = function() {
        return {
            type: constants.CLEAR_CREATE_RESET_ERROR
        };
    }

    var _createPasswordReset = function(email) {
        return function(dispatch) {
            passwordUtils.validate_password_reset_request(email)
                .then(function(result) {
                    if (result === true) {
                        dispatch(_requestReset());
                        api.post('/proxy/v1/users/password-reset', {
                            "email": email,
                            "isWeb": true
                        }).then(function(data) {
                            dispatch(_createResetSuccess(data));
                        }).catch(function(error) {
                            if(error.response){
                                dispatch(_createResetError(error.response));
                            }else{
                                dispatch(commonActions.setGenericError('', error.message));
                            }
                        });
                    } else {
                        dispatch(_validationError(result));
                    }
                })
        };
    }

    return {
        createPasswordReset: _createPasswordReset,
        clearError: _clearError
    }
})();

module.exports = ResetPassword;



// WEBPACK FOOTER //
// ./src/common/modules/password/actions/password-reset-request.js